import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule} from '@angular/forms';

import {PreparationComponent} from './preparation/preparation.component';
import {GameTypeComponent} from './preparation/game-type/game-type.component';
import {PlayerConfigComponent} from './preparation/player-config/player-config.component';
import {PlayerProfileComponent} from './preparation/player-config/player-profile/player-profile.component';
import {GameComponent} from './game/game.component';
import {InfoPageComponent} from './preparation/landing/info-page/info-page.component';
import {HttpClientModule} from '@angular/common/http';
import {LandingComponent} from './preparation/landing/landing.component';
import {ChooseAvatarComponent} from './preparation/player-config/player-profile/choose-avatar/choose-avatar.component';
import {PlaatjesTekstenComponent} from './game/plaatjes-teksten/plaatjes-teksten.component';
import {PcDialogComponent} from './preparation/player-config/pc-dialog/pc-dialog.component';
import {GameDialogComponent} from './game/game-dialog/game-dialog.component';
import {VraagComponent} from './game/vraag/vraag.component';
import {StellingComponent} from './game/stelling/stelling.component';
import {OrderComponent} from './order/order.component';
import {EndquestionsComponent} from './game/endquestions/endquestions.component';
import {EndquestionFeedbackComponent} from './game/endquestions/endquestion-feedback/endquestion-feedback.component';
import {EndquestionAnxchoiceComponent} from './game/endquestions/endquestion-anxchoice/endquestion-anxchoice.component';
import {PpDialogComponent} from './preparation/player-config/player-profile/pp-dialog/pp-dialog.component';
import {EaDialogComponent} from './game/endquestions/endquestion-anxchoice/ea-dialog/ea-dialog.component';
import {StellingContentComponent} from './game/stelling/stelling-content/stelling-content.component';
import {VraagContentComponent} from './game/vraag/vraag-content/vraag-content.component';
import {QuizComponent} from './game/quiz/quiz.component';
import {QuizContentComponent} from './game/quiz/quiz-content/quiz-content.component';
import {WisdomcardDialogComponent} from './game/wisdomcard-dialog/wisdomcard-dialog.component';
import {MysterycardsDialogComponent} from './game/mysterycards-dialog/mysterycards-dialog.component';
import {StartgameDialogComponent} from './game/startgame-dialog/startgame-dialog.component';
import {EndgameDialogComponent} from './game/endquestions/endgame-dialog/endgame-dialog.component';
import {AdminModule} from './admin/admin.module';
import { ConfirmationComponent } from './order/confirmation/confirmation.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AdminModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    PreparationComponent,
    GameTypeComponent,
    PlayerConfigComponent,
    PlayerProfileComponent,
    GameComponent,
    InfoPageComponent,
    LandingComponent,
    ChooseAvatarComponent,
    PlaatjesTekstenComponent,
    PcDialogComponent,
    GameDialogComponent,
    VraagComponent,
    StellingComponent,
    OrderComponent,
    EndquestionsComponent,
    EndquestionFeedbackComponent,
    EndquestionAnxchoiceComponent,
    PpDialogComponent,
    EaDialogComponent,
    StellingContentComponent,
    VraagContentComponent,
    QuizComponent,
    QuizContentComponent,
    WisdomcardDialogComponent,
    MysterycardsDialogComponent,
    StartgameDialogComponent,
    EndgameDialogComponent,
    ConfirmationComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
